import { LOGOUT } from '../actionTypes'

export const logout = () => ({
  type: LOGOUT,
})
